import CodingProjectsStyles from "./CodingProjects.module.css"
import BordersStyles from './Borders.module.css';
import { CodingProjectsLayout } from './Borders';
import { HeaderElement } from "./Header";
import OpenBookCover from "./photos/BookDecorWebP/BookofAbdul_BookCover.webp";
import FrontBookCover from "./photos/BookDecorWebP/BookofAbdul_FrontBookCover.webp";
import BackBookCover from "./photos/BookDecorWebP/BookofAbdul_BackBookCover.webp";
import IndividualPage from "./photos/BookDecorWebP/BookofAbdul_Pages(Individual).webp";
import SigilDec from "./photos/BookDecorWebP/BookofAbdul_SigilDecoration.webp";
import CodingPiece1 from "./photos/BookContent/CodingProjects/TheWizardsAbodeHomepage.png";
import CodingPiece2 from "./photos/BookContent/CodingProjects/TheWizardsAbode_ImagePost.png";
import CodingPiece3 from "./photos/BookContent/CodingProjects/TheWizardsAbode_LogoOrbs.png";
import CodingPiece4 from "./photos/BookContent/CodingProjects/TheWizardsAbode_GlowingOrbsTogether.png";
import CodingPiece5 from "./photos/BookContent/CodingProjects/MovAI_OpeningScreen.png";
import CodingPiece6 from "./photos/BookContent/CodingProjects/MovAI_Recommendations.png";
import CodingPiece7 from "./photos/BookContent/CodingProjects/MovAI_GenreLogos.png";
import CodingPiece8 from "./photos/BookContent/CodingProjects/MovAI_Logo(RegularV3).png";
import CodingPiece9A from "./photos/BookContent/CodingProjects/PhantomFrenzy_TitleScreen.png";
import CodingPiece9B from "./photos/BookContent/CodingProjects/PhantomFrenzy_Animation_WEBM.webm";
import CodingPiece9C from "./photos/BookContent/CodingProjects/PhantomFrenzy_Animation_MP4.mp4";
import CodingPiece10 from "./photos/BookContent/CodingProjects/PhantomFrenzy_CharacterSelect.png";
import CodingPiece11 from "./photos/BookContent/CodingProjects/PhantomFrenzy_UIPauseGameplay.png";
import CodingPiece12 from "./photos/BookContent/CodingProjects/PhantomFrenzy_Logo.png";
import CodingPiece13 from "./photos/BookContent/CodingProjects/ZelldenRing_SignIn.png";
import CodingPiece14 from "./photos/BookContent/CodingProjects/ZelldenRing_Payment.png";
import CodingPiece15 from "./photos/BookContent/CodingProjects/ZelldenRing_Signup.png";
import CodingPiece16 from "./photos/BookContent/CodingProjects/ZelldenRing_Logo.png";
import CodingPiece17 from "./photos/BookContent/CodingProjects/PokerGame_Gameplay.png";
import CodingPiece18 from "./photos/BookContent/CodingProjects/PokerGame_Login.png";
import CodingPiece19 from "./photos/BookContent/CodingProjects/PokerGame_LobbySelect.png";
import CodingPiece20 from "./photos/BookContent/CodingProjects/PokerGame_AboutMessage.png";
import CodingDownload from "./photos/BookContent/CodingProjects/MovAIFinalPresentationSlides.zip"
import CodingDownload2 from "./photos/BookContent/CodingProjects/PhantomFrenzyDocs.zip"

/**
 * TODO: create thumbnails for all images.
 */

const open = 
    {
        title: "OpenBookCover",
        photo: OpenBookCover,
        id: 1
    };

const page = 
    {
        title: "IndividualPage",
        photo: IndividualPage,
        id: 2
    };

const decs = 
    {
        title: "SigilDecoration",
        photo: SigilDec,
        id: 3
    };

const front = 
    {
        title: "FrontBookCover",
        photo: FrontBookCover,
        id: 4
    };

const back = 
    {
        title: "BackBookCover",
        photo: BackBookCover,
        id: 5
    };

const pagenums = 13;

export function CodingProjects() {

    const Info = {
        maintitle: "The Wizard's Abode",
        description: `The very first website I made for my Web Development college course, 
        it's a fantasy-inspired full-stack image site.`,
        caption1: `Created image posting + comment section via Node.js, Express 
        and MySQL, based on professor examples`,
        caption2: "Implemented background changer via CSS animation techniques and JS functions",
        caption3: "Designed original custom backgrounds, logos and artwork via Paint.net, CSS and own drawings",
        web1: "GitHub",
        web2: "YouTube",
        web3: "Docs",
        icon1: "fa-brands fa-github",
        icon2: "fa-brands fa-youtube",
        icon3: "fa-regular fa-file-pdf",
        link1: "https://github.com/abdulbarrie/The-Wizard-s-Abode",
        link2: "https://www.youtube.com/watch?v=UkOAvBtviCw",
        link3: "https://docs.google.com/document/d/1-WNdEXrcOXV69QsCE4CV-pYG2P72-f9oUHcikH-RHD4/edit?tab=t.0#heading=h.2mq6ybasmyyq"
    };
    const Photo1 = 
    {
        title: "The Wizard's Abode Homepage",
        photo: CodingPiece1,
        id: 1
    };
    const Photo2 = 
    {
        title: "The Wizard's Abode Image Post",
        photo: CodingPiece2,
        id: 2
    };
    const Photo3 = 
    {
        title: "The Wizard's Abode Logo & Orbs",
        photo: CodingPiece3,
        id: 3
    };
    const Photo4 = 
    {
        title: "The Wizard's Abode Orbs Together",
        photo: CodingPiece4,
        id: 3
    };

    // Trick to make animation play only on header click.
    let value = false;
    if (HeaderElement.GetHeader === "BoA-header-coding-projects") {
        value = true;
    }
    console.debug("Test value? " + value);

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={CodingProjectsStyles["BoA-individual-pages"]} value={value}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Codepage-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "4"}}>
                <CodingProjectsLayout 
                section="Coding Projects"
                img1={decs.photo} 
                alt1={decs.title}
                img2={Photo1.photo}
                alt2={Photo1.title}
                img3={Photo2.photo}
                alt3={Photo2.title}
                img4={Photo3.photo}
                alt4={Photo3.title}
                img5={Photo4.photo}
                alt5={Photo4.title}
                title={Info.maintitle}
                description={Info.description}
                cap1={Info.caption1}
                cap2={Info.caption2}
                cap3={Info.caption3}
                web1={Info.web1}
                web2={Info.web2}
                web3={Info.web3}
                icon1={Info.icon1}
                icon2={Info.icon2}
                icon3={Info.icon3}
                link1={Info.link1}
                link2={Info.link2}
                link3={Info.link3}/>
            </div>
        </section>
    );
}

export function CodingProjects2() {
    const Info = {
        maintitle: "MovAI",
        description: `As the front-end lead for a Software Engineering group project,
        I contributed to an AI-based movie recommendation generator.`,
        caption1: "Designed hi-fi UI mockups via Figma (see link below), and implemented designs via React and CSS",
        caption2: "Drew individual logos for genres, timelines and movie reels via Paint.net and CSS",
        caption3: "Created MovAI logo via Paint.net photo editing software.",
        web1: "GitHub",
        web2: "Figma",
        web3: "Docs",
        icon1: "fa-brands fa-github",
        icon2: "fa-brands fa-figma",
        icon3: "fa-regular fa-file-pdf",
        link1: "https://github.com/abdulbarrie/MovAI",
        link2: `https://www.figma.com/design/DiIu8eSnUKclwibu3W0Wyh/MovAI-Design-%231---Login%2FSignup?node-id=2-2&t=uDVIgyZlHk9iR88I-1`,
        link3: CodingDownload
    };
    const Photo1 = 
    {
        title: "MovAI Opening Screen",
        photo: CodingPiece5,
        id: 1
    };
    const Photo2 = 
    {
        title: "MovAI Recommendations Mockup",
        photo: CodingPiece6,
        id: 2
    };
    const Photo3 = 
    {
        title: "MovAI Genre Logos Recommendations",
        photo: CodingPiece7,
        id: 4
    };
    const Photo4 = 
    {
        title: "MovAI Logo",
        photo: CodingPiece8,
        id: 5
    };

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={CodingProjectsStyles["BoA-individual-pages"]} id={CodingProjectsStyles["BoA-Code2-pages"]}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Codepage2-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "5"}}>
                <CodingProjectsLayout 
                section="Coding Projects"
                img1={decs.photo} 
                alt1={decs.title}
                img2={Photo1.photo}
                alt2={Photo1.title}
                img3={Photo2.photo}
                alt3={Photo2.title}
                img4={Photo3.photo}
                alt4={Photo3.title}
                img5={Photo4.photo}
                alt5={Photo4.title}
                title={Info.maintitle}
                description={Info.description}
                cap1={Info.caption1}
                cap2={Info.caption2}
                cap3={Info.caption3}
                web1={Info.web1}
                web2={Info.web2}
                web3={Info.web3}
                icon1={Info.icon1}
                icon2={Info.icon2}
                icon3={Info.icon3}
                link1={Info.link1}
                link2={Info.link2}
                link3={Info.link3}/>
            </div>
        </section>
    );
}

export function CodingProjects3() {

    const Info = {
        maintitle: "Phantom Frenzy",
        description: `A horror-fantasy online multiplayer game built with Unity,
        in which I served as my group's UI programmer, animator and documentarian.`,
        caption1: `Designed tombstone-like character select and main menus with animations 
        via Unity, C# scripts and Paint.net.`,
        caption2: "Implemented pause and settings menus with revised HUD design via Unity and Paint.net designs.",
        caption3: "Created logo via Paint.net, among minor revisions to character concept art.",
        web1: "GitHub",
        web2: "YouTube",
        web3: "Docs",
        icon1: "fa-brands fa-github",
        icon2: "fa-brands fa-youtube",
        icon3: "fa-regular fa-file-pdf",
        link1: "",
        link2: "https://www.youtube.com/watch?v=78S_49avYmc",
        link3: CodingDownload2
    };
    const Photo1 = 
    {
        title: "Phantom Frenzy Title Screen Animation",
        photo: CodingPiece9A,
        vid1: CodingPiece9B,
        vid2: CodingPiece9C,
        id: 1
    };
    const Photo2 = 
    {
        title: "Phantom Frenzy Title Screen Animation",
        photo: CodingPiece10,
        id: 2
    };
    const Photo3 = 
    {
        title: "Phantom Frenzy Title Screen Animation",
        photo: CodingPiece11,
        id: 3
    };
    const Photo4 = 
    {
        title: "Phantom Frenzy Title Screen Animation",
        photo: CodingPiece12,
        id: 4
    };

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={CodingProjectsStyles["BoA-individual-pages"]} id={CodingProjectsStyles["BoA-Code3-pages"]}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Codepage3-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "6"}}>
                <CodingProjectsLayout 
                section="Coding Projects"
                img1={decs.photo} 
                alt1={decs.title}
                img2={Photo1.photo}
                alt2={Photo1.title}
                vid1={Photo1.vid1}
                vid2={Photo1.vid2}
                img3={Photo2.photo}
                alt3={Photo2.title}
                img4={Photo3.photo}
                alt4={Photo3.title}
                img5={Photo4.photo}
                alt5={Photo4.title}
                title={Info.maintitle}
                description={Info.description}
                cap1={Info.caption1}
                cap2={Info.caption2}
                cap3={Info.caption3}
                web1={Info.web1}
                web2={Info.web2}
                web3={Info.web3} 
                icon1={Info.icon1}
                icon2={Info.icon2}
                icon3={Info.icon3}
                link1={Info.link1}
                link2={Info.link2}
                link3={Info.link3}/>
            </div>
        </section>
    );
}

export function CodingProjects4() {
    const Info = {
        maintitle: "Zell-den Ring",
        description: `A payment website inspired by the Elden Ring video game,
        where I worked with a group on partial front and back end implementation.`,
        caption1: "Assisted with back-end payment via Java and MongoDB.",
        caption2: "Collaborated on front-end designs with CSS.",
        caption3: "Designed Elden Ring inspired logo from scratch via Paint.net.",
        web1: "GitHub",
        // web2: "Docs",
        icon1: "fa-brands fa-github",
        // icon2: "fa-regular fa-file-pdf",
        link1: "https://github.com/sfsu-csc413-04-sp22/final-project-zell-den-ring",
        // link2: ""
    };

    const Photo1 = 
    {
        title: "Zell-den Ring Sign In",
        photo: CodingPiece13,
        id: 1
    };
    const Photo2 = 
    {
        title: "Zell-den Ring Payment",
        photo: CodingPiece14,
        id: 2
    };
    const Photo3 = 
    {
        title: "Zell-den Ring Sign Up",
        photo: CodingPiece15,
        id: 3
    };
    const Photo4 = 
    {
        title: "Zell-den Ring Logo",
        photo: CodingPiece16,
        id: 4
    };

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={CodingProjectsStyles["BoA-individual-pages"]} id={CodingProjectsStyles["BoA-Code4-pages"]}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Codepage4-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "7"}}>
                <CodingProjectsLayout 
                section="Coding Projects"
                img1={decs.photo} 
                alt1={decs.title}
                img2={Photo1.photo}
                alt2={Photo1.title}
                img3={Photo2.photo}
                alt3={Photo2.title}
                img4={Photo3.photo}
                alt4={Photo3.title}
                img5={Photo4.photo}
                alt5={Photo4.title}
                title={Info.maintitle}
                description={Info.description}
                cap1={Info.caption1}
                cap2={Info.caption2}
                cap3={Info.caption3}
                web1={Info.web1}
                web2={Info.web2}
                icon1={Info.icon1}
                icon2={Info.icon2}
                link1={Info.link1}
                link2={Info.link2}/>
            </div>
        </section>
    );
}

export function CodingProjects5() {
    const Info = {
        maintitle: "Online Texas Hold 'Em Poker",
        description: `An online poker game made with Node.js, Handlebars and PostgreSQL 
        in which I assisted mainly with front-end design.`,
        caption1: "Implemented Login designs via CSS, React and Paint.net for button logo.",
        caption2: "Aided in poker lobby design and layout.",
        caption3: "Refined About page with logo and wrote humorous message.",
        web1: "GitHub",
        web2: "Website",
        icon1: "fa-brands fa-github",
        icon2: "fa-solid fa-globe",
        link1: "https://github.com/csc-667-fall-2022-sfsu-roberts/term-project-team-pcarkpab",
        link2: "https://pcarkpab-poker.onrender.com/"
    };

    const Photo1 = 
    {
        title: "Poker Game Gameplay",
        photo: CodingPiece17,
        id: 1
    };
    const Photo2 = 
    {
        title: "Poker Game Login",
        photo: CodingPiece18,
        id: 2
    };
    const Photo3 = 
    {
        title: "Poker Game Lobby Select",
        photo: CodingPiece19,
        id: 3
    };
    const Photo4 = 
    {
        title: "Poker Game About Message",
        photo: CodingPiece20,
        id: 4
    };

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={CodingProjectsStyles["BoA-individual-pages"]} id={CodingProjectsStyles["BoA-Code5-pages"]}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Codepage5-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "8"}}>
                <CodingProjectsLayout 
                section="Coding Projects"
                img1={decs.photo} 
                alt1={decs.title}
                img2={Photo1.photo}
                alt2={Photo1.title}
                img3={Photo2.photo}
                alt3={Photo2.title}
                img4={Photo3.photo}
                alt4={Photo3.title}
                img5={Photo4.photo}
                alt5={Photo4.title}
                title={Info.maintitle}
                description={Info.description}
                cap1={Info.caption1}
                cap2={Info.caption2}
                cap3={Info.caption3}
                web1={Info.web1}
                web2={Info.web2}
                icon1={Info.icon1}
                icon2={Info.icon2}
                link1={Info.link1}
                link2={Info.link2}/>
            </div>
        </section>
    );
}